import AdDesignJobs from "../controllers/AdDesignJobs";
import AdDesignJobsAnnotationFiles from "../controllers/AdDesignJobsAnnotationFiles";
import AdDesignJobsAnnotations from "../controllers/AdDesignJobsAnnotations";
import AdDesignJobsAssetPreviews from "../controllers/AdDesignJobsAssetPreviews";
import AdDesignJobsClientLibrary from "../controllers/AdDesignJobsClientLibrary";
import AdDesignJobsCombines from "../controllers/AdDesignJobsCombines";
import AdDesignJobsEvents from "../controllers/AdDesignJobsEvents";
import AdDesignJobsJobFeedbacks from "../controllers/AdDesignJobsJobFeedbacks";
import AdDesignJobsWizard from "../controllers/AdDesignJobsWizard";
import Admin from "../controllers/Admin";
import AdminAdSpecs from "../controllers/AdminAdSpecs";
import AdminPublications from "../controllers/AdminPublications";
import AdminPublicationsJobs from "../controllers/AdminPublicationsJobs";
import AdminTerritories from "../controllers/AdminTerritories";
import AdminUsers from "../controllers/AdminUsers";
import AnnotationsAssets from "../controllers/AnnotationsAssets";
import Application from "../controllers/Application";
import ArticleJobs from "../controllers/ArticleJobs";
import ArticleJobsAssets from "../controllers/ArticleJobsAssets";
import ArticleJobsPriorities from "../controllers/ArticleJobsPriorities";
import ArticleJobsSettings from "../controllers/ArticleJobsSettings";
import Cart from "../controllers/Cart";
import ClientsDigitalJobs from "../controllers/ClientsDigitalJobs";
import ComponentPreviewController from "../controllers/ComponentPreviewController";
import DesignTeamUsers from "../controllers/DesignTeamUsers";
import DesignTeams from "../controllers/DesignTeams";
import DesignTeamsDesignTeamUsers from "../controllers/DesignTeamsDesignTeamUsers";
import DesignTeamsTerritories from "../controllers/DesignTeamsTerritories";
import DigitalJobs from "../controllers/DigitalJobs";
import DigitalJobsAnnotations from "../controllers/DigitalJobsAnnotations";
import DigitalJobsClientLibrary from "../controllers/DigitalJobsClientLibrary";
import DigitalJobsEvents from "../controllers/DigitalJobsEvents";
import DigitalJobsWizard from "../controllers/DigitalJobsWizard";
import ErPlusJobs from "../controllers/ErPlusJobs";
import ErPlusJobsAnnotations from "../controllers/ErPlusJobsAnnotations";
import ErPlusJobsClientLibrary from "../controllers/ErPlusJobsClientLibrary";
import ErPlusJobsWizard from "../controllers/ErPlusJobsWizard";
import ExtraCopies from "../controllers/ExtraCopies";
import ManualOrderEntries from "../controllers/ManualOrderEntries";
import Prepress from "../controllers/Prepress";
import PrintConfigurations from "../controllers/PrintConfigurations";
import PubRevisionsReviews from "../controllers/PubRevisionsReviews";
import PublicationJobs from "../controllers/PublicationJobs";
import PublicationJobsAdPlacements from "../controllers/PublicationJobsAdPlacements";
import PublicationJobsAddressLists from "../controllers/PublicationJobsAddressLists";
import PublicationJobsAnnotations from "../controllers/PublicationJobsAnnotations";
import PublicationJobsArticleJobs from "../controllers/PublicationJobsArticleJobs";
import PublicationJobsArticleJobsAssetPreviews from "../controllers/PublicationJobsArticleJobsAssetPreviews";
import PublicationJobsEmailLists from "../controllers/PublicationJobsEmailLists";
import PublicationJobsEmailSubscriptions from "../controllers/PublicationJobsEmailSubscriptions";
import PublicationJobsEvents from "../controllers/PublicationJobsEvents";
import PublicationJobsManagedLists from "../controllers/PublicationJobsManagedLists";
import PublicationJobsOverages from "../controllers/PublicationJobsOverages";
import PublicationJobsProductionData from "../controllers/PublicationJobsProductionData";
import PublicationJobsSamples from "../controllers/PublicationJobsSamples";
import PublicationManagements from "../controllers/PublicationManagements";
import ReportJobs from "../controllers/ReportJobs";
import ResidentBusinessGuides from "../controllers/ResidentBusinessGuides";
import ResidentBusinessGuidesBusinessListingUploads from "../controllers/ResidentBusinessGuidesBusinessListingUploads";
import ResidentBusinessGuidesBusinessListings from "../controllers/ResidentBusinessGuidesBusinessListings";
import Searches from "../controllers/Searches";
import SimplifiAudiences from "../controllers/SimplifiAudiences";
import TeamMembers from "../controllers/TeamMembers";
import Territories from "../controllers/Territories";
import UserAssignedAds from "../controllers/UserAssignedAds";
import UserAssignedPubs from "../controllers/UserAssignedPubs";
import AdJobQueues from "../controllers/AdJobQueues";
import DigitalJobQueues from "../controllers/DigitalJobQueues";
import StoreCustomLabels from "../controllers/StoreCustomLabels";
import StoreCustomLabelsAnnotations from "../controllers/StoreCustomLabelsAnnotations";
import StorePromosAnnotations from "../controllers/StorePromosAnnotations";
import StorePromos from "../controllers/StorePromos";
import StoreCustomLabelsRecipients from "../controllers/StoreCustomLabelsRecipients";
import StorePromosRecipients from "../controllers/StorePromosRecipients";
import StoreCustomLabelsEvents from "../controllers/StoreCustomLabelsEvents";
import StorePromosEvents from "../controllers/StorePromosEvents";

const Controller = {
  AdDesignJobs,
  AdDesignJobsAnnotationFiles,
  AdDesignJobsAnnotations,
  AdDesignJobsAssetPreviews,
  AdDesignJobsClientLibrary,
  AdDesignJobsCombines,
  AdDesignJobsEvents,
  AdDesignJobsJobFeedbacks,
  AdDesignJobsWizard,
  AdJobQueues,
  Admin,
  AdminAdSpecs,
  AdminPublications,
  AdminPublicationsJobs,
  AdminTerritories,
  AdminUsers,
  AnnotationsAssets,
  Application,
  ArticleJobs,
  ArticleJobsAssets,
  ArticleJobsPriorities,
  ArticleJobsSettings,
  Cart,
  ClientsDigitalJobs,
  DesignTeamUsers,
  DesignTeams,
  DesignTeamsDesignTeamUsers,
  DesignTeamsTerritories,
  DigitalJobQueues,
  DigitalJobs,
  DigitalJobsAnnotations,
  DigitalJobsClientLibrary,
  DigitalJobsEvents,
  DigitalJobsWizard,
  ErPlusJobs,
  ErPlusJobsAnnotations,
  ErPlusJobsClientLibrary,
  ErPlusJobsWizard,
  ExtraCopies,
  ManualOrderEntries,
  Prepress,
  PrintConfigurations,
  PubRevisionsReviews,
  PublicationJobs,
  PublicationJobsAdPlacements,
  PublicationJobsAddressLists,
  PublicationJobsAnnotations,
  PublicationJobsArticleJobs,
  PublicationJobsArticleJobsAssetPreviews,
  PublicationJobsEmailLists,
  PublicationJobsEmailSubscriptions,
  PublicationJobsEvents,
  PublicationJobsManagedLists,
  PublicationJobsOverages,
  PublicationJobsProductionData,
  PublicationJobsSamples,
  PublicationManagements,
  ReportJobs,
  ResidentBusinessGuides,
  ResidentBusinessGuidesBusinessListingUploads,
  ResidentBusinessGuidesBusinessListings,
  Searches,
  SimplifiAudiences,
  StoreCustomLabels,
  StoreCustomLabelsEvents,
  StoreCustomLabelsAnnotations,
  StoreCustomLabelsRecipients,
  StorePromosAnnotations,
  StorePromosRecipients,
  StorePromos,
  StorePromosEvents,
  TeamMembers,
  Territories,
  UserAssignedAds,
  UserAssignedPubs,
};

export default class ControllerLoader {
  static load() {
    try {
      const appController = new Controller.Application(
        $("#controller-loader-params").data()
      );
      appController.load();

      const controller = $("#controller-loader-params").data("controller");
      let action = $("#controller-loader-params").data("action");
      if (controller && Controller[controller] !== undefined) {
        this.controller = new Controller[controller](
          $("#controller-loader-params").data()
        );
        if (this.controller[action]) {
          if (process.env.RAILS_ENV == "development") {
            console.log(`Found ${controller}#${action}`);
          }
          return this.controller[action]();
        } else {
          if (process.env.RAILS_ENV == "development") {
            console.log(`Not found ${controller}#${action}`);
          }
        }
      } else {
        if (process.env.RAILS_ENV == "development") {
          console.log(`Not found ${controller}#${action}`);
        }
      }
    } catch (err) {
      if (process.env.RAILS_ENV === "development") {
        console.log("No controller info found! Maybe this is the component preview page?");
        this.controller = new ComponentPreviewController();
      }
    }
  }

  static unload(event) {
    N2.unbindHandlers();
    if (this.controller) {
      if (this.controller.unload) {
        this.controller.unload();
      }
      this.controller = null;
    }
    return undefined;
  }
}
